const accordionItem = document.querySelectorAll(".js-accordion-item");

accordionItem.forEach((item) => {
  const button = item.querySelector(".accordion__single-item-title button");
  button.addEventListener("click", () => {
    // Check if clicked item is already active
    const isActive = item.classList.contains("active");

    // Find closest accordion
    const accordion = item.closest(".features-accordion");

    // If clicking an already active item, just toggle it closed
    if (isActive) {
      item.classList.remove("active");

      // Remove is-active class from all accordion images
      const accordionImages = accordion.querySelector(".js-accordion-images");
      if (accordionImages) {
        accordionImages.querySelectorAll(".is-active").forEach((image) => {
          image.classList.remove("is-active");
        });
      }
    } else {
      // Remove active class from all accordion items
      if (accordion) {
        accordion.querySelectorAll(".js-accordion-item").forEach((item) => {
          item.classList.remove("active");
        });
      }

      // Add active class to clicked accordion item
      item.classList.add("active");

      // Get 'data-title' from accordionItem
      const accordionItemTitle = item.getAttribute("data-title");

      // Find closest .js-accordion-images
      const accordionImages = accordion.querySelector(".js-accordion-images");

      if (accordionImages && accordionItemTitle) {
        // Find closest .js-accordion-image with matching 'data-title'
        const accordionImage = accordionImages.querySelector(
          `[id="${accordionItemTitle}"]`
        );

        // Remove is-active class from all accordion images
        accordionImages.querySelectorAll(".is-active").forEach((image) => {
          image.classList.remove("is-active");
        });

        // Add is-active class to accordionImage
        if (accordionImage) {
          accordionImage.classList.add("is-active");
        }
      }
    }
  });
});
